import { RESET_WIDGET } from '../../actions/common';
import { SELECT_PAYMENT_METHOD, SET_PAYMENT_METHODS } from '../../actions/paymentMethods';
import { TReduxActions } from '../../types/actions';
import { IPaymentMethodsState } from '../../types/redux/paymentMethods';

const defaultState: IPaymentMethodsState = {
  methods: {},
  methodIds: [],
  selectedMethodId: null,
};

export const paymentMethodsReducer = (state: IPaymentMethodsState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case SET_PAYMENT_METHODS:
      return {
        ...state,
        ...action.payload,
      };

    case SELECT_PAYMENT_METHOD:
      return {
        ...state,
        selectedMethodId: action.payload,
      };

    case RESET_WIDGET:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
